import { render, staticRenderFns } from "./exception.vue?vue&type=template&id=de4e444a&scoped=true"
import script from "./exception.vue?vue&type=script&lang=js"
export * from "./exception.vue?vue&type=script&lang=js"
import style0 from "./exception.vue?vue&type=style&index=0&id=de4e444a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4e444a",
  null
  
)

export default component.exports